'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.manualTrack = manualTrack;

var _support = require('helpers/support');

var _localStorage = require('utils/localStorage');

var _ApiTracking = require('./ApiTracking');

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnalyticService = {
  GEO_LOCATION: {},
  DEVICE_INFO: {},
  setGeoLocation: function setGeoLocation(geo) {
    if (geo && (typeof geo === 'undefined' ? 'undefined' : (0, _typeof3.default)(geo)) === 'object') {
      this.GEO_LOCATION = (0, _extends3.default)({}, this.GEO_LOCATION, geo);
    }
  },
  _appInfo: function _appInfo() {
    /* applicationName, version, id */
    return {
      applicationName: 'Lookme Web',
      version: navigator.appVersion,
      id: location.hostname
    };
  },
  _geoLocation: function _geoLocation() {
    if (!this.GEO_LOCATION) return {};
    /*
    adminArea, country, countryCode, feature, formattedAddress, locality, lat, lng,
    postalCode, streetName, streetNumber, subAdminArea, subLocality
    */
    return (0, _extends3.default)({}, this.GEO_LOCATION);
  },
  _deviceInfo: function _deviceInfo() {
    if (!this.DEVICE_INFO) return {};
    /*
    host, userAgent, language, deviceToken, ipAddress, serialNumber, uniqueId, display, carrier, mobileBrandName,
    mobileModelName, mobileMarketingName, operatingSystem, operatingSystemVersion, timeZoneOffset
    */
    return (0, _extends3.default)({}, this.DEVICE_INFO, {
      host: location.href,
      userAgent: navigator.userAgent,
      language: navigator.language,
      uniqueId: (0, _localStorage.localStore)().get('uniqueId')
    });
  },
  track: function track(tracking) {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var date, body;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_config2.default.trackingEnabled) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              date = new Date();
              body = (0, _extends3.default)({}, _support.Helper.getScreen(), tracking, {
                // userId,
                timeClick: date.toString(),
                // deviceName: getDeviceName,
                device: (0, _extends3.default)({}, _this._deviceInfo(), {
                  timeZoneOffset: date.getTimezoneOffset().toString()
                }),
                geo: (0, _extends3.default)({}, _this._geoLocation()),
                appInfo: (0, _extends3.default)({}, _this._appInfo())
              });

              // const body = JSON.parse(jsonBody);

              console.log('@Track: ', body);
              _context.next = 7;
              return _ApiTracking.client.post('/track/component', { jsonData: body });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  setUniqueId: function setUniqueId() {
    var uniqueId = (0, _localStorage.localStore)().get('uniqueId');
    if (!uniqueId) {
      (0, _localStorage.localStore)().set('uniqueId', _support.Helper.newGuid());
    }
  },
  setUTM: function setUTM() {
    var href = location.href;
    if (href && href.indexOf('utm_') !== -1) {
      var now = new Date();
      var expiredAt = new Date(now.toString());
      expiredAt.setHours(expiredAt.getHours() + 24);
      // expiredAt cách thời gian vào là 24 tiếng.
      (0, _localStorage.localStore)().set('utmData', {
        link: href,
        createdAt: now.toString(),
        expiredAt: expiredAt.toString()
      });
    }
  },
  getUTM: function getUTM() {
    var UTM = (0, _localStorage.localStore)().get('utmData');
    if (UTM && UTM.expiredAt && UTM.link) {
      var now = new Date();
      var expire = new Date(UTM.expiredAt);
      if (now < expire) {
        return UTM;
      }
      (0, _localStorage.localStore)().clear('utmData');
    }
    return null;
  }
};
function manualTrack(track) {
  if (track && track.geo) {
    AnalyticService.setGeoLocation(track.geo);
  }
  AnalyticService.track(track);
}

exports.default = AnalyticService;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/AnalyticService.js
// module id = 365
// module chunks = 0